import React from 'react'
import { LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { StepBreadcrumbs } from './StepBreadcrumbs'
import type { StepBreadcrumbsProps } from './StepBreadcrumbs'
import { StepBreadcrumbsLegacy } from './StepBreadcrumbsLegacy'

export const StepBreadcrumbsWrapper: React.FC<StepBreadcrumbsProps> = props => {
  const isUnifiedMarkAllItemFulfillmentEnabled = getFeatureFromCache(
    LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT
  )

  return isUnifiedMarkAllItemFulfillmentEnabled ? (
    <StepBreadcrumbs {...props} />
  ) : (
    <StepBreadcrumbsLegacy {...props} />
  )
}

export { StepBreadcrumbsWrapper as StepBreadcrumbs }
export type { StepBreadcrumbsProps }
